module.exports = __webpack_public_path__ + "img/smicon.0a21903d.png";